/**
 * Created by Andrey Popov on 4/25/25.
 */

const StaticDataSource = function (getDataFunc) {
    return {
        getData: getDataFunc,
        on: function () {},
        destructor: function () {}
    };
};